module.exports = __webpack_public_path__ + "static/media/icon-arrow-down-dark.3902af32.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-arrow-down-dark.svg
// module id = 474
// module chunks = 7